import React from 'react';
import { SelectField, SmallBodyText } from '../../../../../ui-toolkit';
import { SummaryItemWithEdit } from '../../../../shared/Summary/SummaryItem/SummaryItemWithEdit';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';
import { optionsFromDisplay } from '../../../../../ui-toolkit/enums/optionsFromDisplay';
import { DisplayPropertyType } from '../../../../../ui-toolkit/orders/interfaces/ePropertyType';

export const PropertyType: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();
  return (
    <SummaryItemWithEdit
      label={'Property Type'}
      tab={`other`}
      field={`property_type`}
      onUpdate={(_, value) => onPatchOrderInformation({ propertyType: value ?? null })}
      order={order}
      editControl={SelectField}
      editProps={{ options: optionsFromDisplay(DisplayPropertyType), isClearable: true }}
    >
      {order.transaction.property_type ? (
        DisplayPropertyType[order.transaction.property_type]
      ) : (
        <SmallBodyText intent={`faded`}>-</SmallBodyText>
      )}
    </SummaryItemWithEdit>
  );
};
